import apiClient from "./axios.config";

export const getAllpropertyNameUrl = () => {
  return apiClient.get("/website/all");
};
export const getAllBlogSNameAndUrl = () => {
  return apiClient.get("/website/blogs/all");
};


